module.exports = __webpack_public_path__ + "img/5997fedcc7bd4cffbd350b40d1b5b9824.dbde56ac.jpg";